import { isDeprecatedFilterEnabled } from '@gonfalon/flag-filters/deprecatedFilterUtils';

import { AdditionalFilterOption } from './constants';
import { type FlagFilters } from './records/FlagFilters';

export const clearFilterEnvIfNeeded = (filters: FlagFilters) => {
  let updatedFilters = filters;
  if (
    updatedFilters.status === '' &&
    (isDeprecatedFilterEnabled('hasDataExport') ? updatedFilters.hasDataExport === undefined : true) &&
    updatedFilters.evaluated === undefined &&
    updatedFilters.creationDate === undefined &&
    (isDeprecatedFilterEnabled('targeting') ? updatedFilters.targeting === '' : true) &&
    (isDeprecatedFilterEnabled('followerId') ? updatedFilters.followerId === '' : true)
  ) {
    updatedFilters = updatedFilters.delete(AdditionalFilterOption.ENVIRONMENT);
  }
  return updatedFilters;
};
